import { withDependencies } from '@wix/thunderbolt-ioc'
import { SdkHandlersProvider, LoggerSymbol, ILogger } from '@wix/thunderbolt-symbols'
import { name } from '../symbols'
import { DashboardWixCodeSdkHandlers } from '../types'

export const dashboardWixCodeSdkHandlers = withDependencies(
	[LoggerSymbol],
	(logger: ILogger): SdkHandlersProvider<DashboardWixCodeSdkHandlers> => ({
		getSdkHandlers: () => ({
			[name]: {
				getDashboardApi: () => {},
				postMessageParent: () => {},
				captureError: (e: Error) => {
					logger.captureError(e, {
						tags: { feature: 'feature-dashboard-wix-code-sdk' },
						extra: { origin: 'factory' },
					})
				},
			},
		}),
	})
)
